export const getXHRResponseHeaders = (xhr) => {
    const responseHeaderStrArr = xhr
        .getAllResponseHeaders()
        .trim()
        .split(/[\r\n]+/);
    const headerMap = {};
    responseHeaderStrArr.forEach((header) => {
        const parts = header.split(': ');
        const headerKey = parts.shift();
        const headerValue = parts.join(': ').replace(/['"]+/g, '');
        if (headerKey) {
            headerMap[headerKey.toLowerCase()] = headerValue;
        }
    });
    return headerMap;
};
//# sourceMappingURL=XHRUtils.js.map